<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 


</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment';
import js_logos from '@/assets/js/js_logos.js'


import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  props: [ 'studentID' , 'fees' , 'payments'  ],
  data() {
      return {
          data_student:[],
          data_school:[],
          isLoading:false,
       }
  },

created() {
    // console.log('CREATED')
    this.student_get()
},

methods: {

student_get() {
this.isLoading=true;
// GET SCHHOL INFO
var query = "SELECT * FROM MyMEQ_SCHOOLINFO"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_school = res.data

        var query = `SELECT * FROM MyMEQ_STUDENT WHERE (student_ID = '` + this.studentID + `')`
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { 
            this.data_student = res.data
            this.isLoading=false;
            this.create_pdf()



    });  });
},


 
get_fees:function() {
    var bodySou = [];
//HEADER
      var fila = new Array();
      fila.push({text: "DESCRIPTION", fontSize: 9, bold: true, alignment: 'left', fillColor:'#F5F5F5'});
    //   fila.push({text: "DATE", fontSize: 9, bold: true, alignment: 'left', fillColor:'#F5F5F5'});
      fila.push({text: "AMOUNT", fontSize: 9, bold: true, alignment: 'right', fillColor:'#F5F5F5'});
      bodySou.push(fila);
    for(var i = 0, l = this.fees.length; i < l; i++) {
// TOTALS
//  this.total_pay = this.total_pay + Number(this.data_payments[i].servPay_AMT)

      fila = new Array();
        fila.push({text: this.fees[i].studentFee_DESC, fontSize: 11, bold: true, alignment: 'left'});
        // fila.push({text: moment(this.data_payments[i].servPay_DATE_PAY).format('MMM DD YYYY'), fontSize: 11, bold: true, alignment: 'left'});
        fila.push({text: this.format_money(this.fees[i].studentFee_AMT,"$"), fontSize: 11, bold: true, alignment: 'right'});
        bodySou.push(fila);
    }
    return bodySou;    
},
get_payments:function() {
    var bodySou = [];
//HEADER
      var fila = new Array();
      fila.push({text: "AMOUNT", fontSize: 9, bold: true, alignment: 'right', fillColor:'#F5F5F5'});
      fila.push({text: "DATE", fontSize: 9, bold: true, alignment: 'right', fillColor:'#F5F5F5'});
      fila.push({text: "REC", fontSize: 9, bold: true, alignment: 'center', fillColor:'#F5F5F5'});
        fila.push({text: "REC DATE", fontSize: 9, bold: true, alignment: 'right', fillColor:'#F5F5F5'});

      fila.push({text: "TYPE", fontSize: 9, bold: true, alignment: 'center', fillColor:'#F5F5F5'});
      
      
      bodySou.push(fila);
    for(var i = 0, l = this.payments.length; i < l; i++) {
// TOTALS
//  this.total_pay = this.total_pay + Number(this.data_payments[i].servPay_AMT)

      fila = new Array();
        fila.push({text: this.format_money(this.payments[i].payment_Amount,"$"), fontSize: 11, bold: true, alignment: 'right'});
        fila.push({text: moment(this.payments[i].payment_DueDate).format('MMM DD YYYY'), fontSize: 11, bold: true, alignment: 'right'});

if (this.payments[i].payment_Rec == true){
   fila.push({text: "X", fontSize: 11, bold: true, alignment: 'center'}); 
   fila.push({text: moment(this.payments[i].payment_RecDate).format('MMM DD YYYY'), fontSize: 11, bold: true, alignment: 'right'});
} else {
    fila.push({text: '', fontSize: 11, bold: true, alignment: 'left'}); 
   fila.push({text: "", fontSize: 11, bold: true, alignment: 'left'});
}
 
        


        fila.push({text: this.payments[i].payment_Type, fontSize: 11, bold: true, alignment: 'center'});


        
        
        bodySou.push(fila);
    }
    return bodySou;    
},




create_pdf:function() {

this.isLoading=true;
//  var imgData = this.getBase64FromImageUrl("../../assets/logo.png")

var fees = this.get_fees()
var payments = this.get_payments()

var self = this;
var pdfContent = {
    pageMargins: [ 40, 40, 40, 90 ],

    info: {title:"TEST"},

		header: function(currentPage, pageCount) { 
			return {
				margin: [20, 15],
				fontSize: 10,
				alignment: 'right',
				text: 'Page ' + currentPage.toString() + ' of ' + pageCount
			}; 
        },
		footer: function(currentPage, pageCount) { 
			return {
				margin: [20, 15],
                fontSize: 10,
                color:"gray",
				alignment: 'left',
                columns: [
                    {width: '75%',text:[{text: self.data_school[0].school_NAME + '    ' +  self.data_school[0].school_WEBSITE}],},
                    {width: '*',text:[{text: 'Page ' + currentPage.toString() + ' of ' + pageCount}],},
                ]
			}; 
        },
        

content: [
 
{
margin: [0, 0, 0, 10],
    columns: [ {
            image: sessionStorage.getItem('logo'),
            width:100 
              
				},
				{
					text:[
					{text: this.data_school[0].school_NAME + '\n', fontSize: 12, bold: false, color:"dimgray"},
                    {text: this.data_school[0].school_ADDRESS + ", " + this.data_school[0].school_CITY + ' ' + this.data_school[0].school_PROVINCE + ' ' + this.data_school[0].school_POSTAL + ' ' + '\n', fontSize: 10, bold: false, color:"dimgray"},
                    {text: this.data_school[0].school_TELEPHONE + '     ' + this.data_school[0].school_EMAIL + '\n', fontSize: 10, bold: false, color:"dimgray"},
				
					],
			        style: 'header',
			        alignment: 'right'
			        
				}
      ],
    }, // END CONTENT BLOCK

            {
			columns: [
  {
    width: '*',
    text:[
    {text: this.data_student[0].student_fNAME + ' ' + this.data_student[0].student_lNAME  + '\n', fontSize: 10, bold: false},
    {text: this.data_student[0].student_apt + ' ' + this.data_student[0].student_rueNUM + ' ' + this.data_student[0].student_Address + '\n', fontSize: 10, bold: false},
    {text: this.data_student[0].student_City + ' ' + this.data_student[0].student_Province + '   ' + this.data_student[0].student_Postal + '\n', fontSize: 10, bold: false},
      ], margin: [0, 0, 0, -10],
  },
  {
    width: '*',
    text:[
    {text: '\n', fontSize: 8, bold: false},
    {text: 'Tel : ' + this.data_student[0].student_TelOther  + '\n', fontSize: 10, bold: false},
    {text: 'Email : ' + this.data_student[0].student_eMail  + '\n', fontSize: 10, bold: false},
      ], margin: [0, 0, 0, -10],
  },
  {
    width: '*',
    text:[
    {text: '\n', fontSize: 8, bold: false},
    {text: 'Statement of Account'   + '\n', fontSize: 12, bold: false, alignment: 'right'},
    {text: ' '   + '\n', fontSize: 10, bold: false},
      ], margin: [0, 0, 0, -10],
  },


            ]},

{text: "\n\n", fontSize: 12, bold: true},
// {text: "FEES\n", fontSize: 12, bold: true},

          {
             
    columns: [
  {
    width: '5%',
        text:[{text: '', fontSize: 8, bold: false}],
  },
  {
    width: '90%',
            
            table: {
                //headerRows: 1,
                widths: ['80%','20%'],
                body: fees,
                },
                layout: {
                    fillColor: function(row, col, node) { return row > 0 && row % 2 ? '#F1F5F8' : null; }
                }
            },
  {
    width: '5%',
        text:[{text: '\n', fontSize: 8, bold: false}],
  }
    ]
          },

{text: "\n\n\n", fontSize: 9},

   { columns: [
  {
    width: '5%',   
        text:[{text: '\n', fontSize: 8, bold: false}],
  },
  {
    width: '90%',
            table: {
                //headerRows: 1,
                widths: ['20%','20%','20%','20%','20%'],
                body: payments,
                },
                layout: {
                    fillColor: function(row, col, node) { return row > 0 && row % 2 ? '#F1F5F8' : null; }
                }
            },
  {
    width: '5%',
        text:[{text: '\n', fontSize: 8, bold: false}],
  }
    ] },

{text: "\n\n", fontSize: 12, bold: true},

{         
    columns: [
  {
    width: '33%',
        text:[
        {text: 'OWE\n',  fontSize: 11, bold: true, alignment: 'center'},
        {text: this.format_money(this.data_student[0].student_frais_owe, '$'),  fontSize: 14, bold: true, alignment: 'center'}],
  },
  {
    width: '33%',
        text:[
        {text: 'PAY\n',  fontSize: 11, bold: true, alignment: 'center'},
        {text: this.format_money(this.data_student[0].student_frais_pay, '$'),  fontSize: 14, bold: true, alignment: 'center'}],
  },
  {
    width: '33%',
        text:[
        {text: 'SOLDE\n',  fontSize: 11, bold: true, alignment: 'center'},
        {text: this.format_money(this.data_student[0].student_frais_solde, '$'),  fontSize: 14, bold: true, alignment: 'center'}],
  }
 ]  }  ,


  ] // END CONTENT

};


   pdfMake.createPdf(pdfContent).open();
//    pdfMake.createPdf(pdfContent).download(this.quoteObj.quote_NUM+'.pdf');
    this.isLoading=false;
    this.$emit('emit_pdf_done')

}, // END CREATE PDF

getBase64FromImageUrl(url) {
    var img = new Image();

    img.setAttribute('crossOrigin', 'anonymous');

    img.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width =this.width;
        canvas.height =this.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        alert(dataURL.replace(/^data:image\/(png|jpg);base64,/, ""));
    };

    img.src = url;
},

// const {createCanvas, loadImage} = require('canvas');
// function getImage(url, size) {
//     return loadImage(url).then(image => {
//         const canvas = createCanvas(size, size);
//         let ctx = canvas.getContext('2d');
//         ctx.drawImage(image, 0, 0);
//         return canvas.toDataURL();
//     });
// }
format_money:function (n, currency) {
    try {return currency + parseFloat(n).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");}
    catch(err) {return '-' }
},

}, // END METHODS


} // END EXPORT
</script>
